import { useEffect } from 'react';

export default function BlueskyEmbed({ updateOn }: any) {
  useEffect(() => {
    try {
      const script = document.createElement('script');
      script.src = 'https://embed.bsky.app/static/embed.js';
      document.getElementsByTagName('body')[0].appendChild(script);
    } catch {
      /*swallow exception*/
    }
  }, [updateOn]);

  return null;
}
